export default class LanguageUtil {
  static updateLanguage(props, language) {
    props.i18n.changeLanguage(language);
    localStorage.setItem("lang", language);
  }
}
